(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-info/assets/javascripts/select.js') >= 0) return;  svs.modules.push('/components/components/cookies-info/assets/javascripts/select.js'); 
'use strict';

const logger = svs.core.log.getLogger('component:cookies_info');
svs.components.cookies_info.select = function () {
  return {
    show: cookieDialogInfoObject => {
      logger.info('Show adjust cookie consent dialog for visitor');
      const message = [];
      message.push({
        align: svs.components.dialog.message.align.LEFT,
        text: svs.components.cookies_info.templates.adjust_cookies(),
        type: svs.components.dialog.message.TEXT
      });
      message.push({
        align: svs.components.dialog.message.align.LEFT,
        type: svs.components.dialog.message.CHECKBOX,
        block: true,
        id: 'cookies-dialog-analytics',
        value: 'analytics',
        text: "Analys och statistik f\xF6r att s\xE4kerst\xE4lla att webbplatsen fungerar och f\xF6r att kunna g\xF6ra f\xF6rb\xE4ttringar." + " Vi anv\xE4nder analystj\xE4nster fr\xE5n tredje part inkl. Google. Se Googles information om behandling av personuppgifter h\xE4r:" + " <a href=\"https://policies.google.com/privacy?hl=sv\" target=\"_blank\">https://policies.google.com/privacy?hl=sv</a>."
      });
      message.push({
        align: svs.components.dialog.message.align.LEFT,
        type: svs.components.dialog.message.CHECKBOX,
        block: true,
        id: 'cookies-dialog-provision',
        value: 'provision',
        text: "M\xF6jlighet att betala ut provisioner till samarbetspartners.                  "
      });
      message.push({
        align: svs.components.dialog.message.align.LEFT,
        type: svs.components.dialog.message.CHECKBOX,
        block: true,
        id: 'cookies-dialog-ad',
        value: 'ad',
        text: 'Anpassa budskap till dig när du besöker andra webbplatser och sociala medier (så kallad retargeting).'
      });
      message.push({
        align: svs.components.dialog.message.align.LEFT,
        type: svs.components.dialog.message.CHECKBOX,
        block: true,
        id: 'cookies-dialog-personalized',
        value: 'personalized',
        text: "Som kund, f\xE5 mer relevant kommunikation i ".concat(cookieDialogInfoObject.corporateName, "s kanaler som t ex e-post eller ").concat(cookieDialogInfoObject.corporateUrl, ".")
      });
      message.push({
        align: svs.components.dialog.message.align.LEFT,
        text: "* Se fullst\xE4ndig info om <a href=\"".concat(cookieDialogInfoObject.cookieInfoUrl, "\">cookies</a>."),
        type: svs.components.dialog.message.TEXT
      });
      const adjustCookiePreferences = new svs.components.dialog.Confirm({
        actions: [{
          title: 'Tillbaka',
          callback: () => {
            svs.components.cookies_info.cookieInfo.show(cookieDialogInfoObject);
            adjustCookiePreferences.close();
          }
        }, {
          title: 'Spara',
          callback() {
            const personalized = $('#cookies-dialog-personalized').length > 0 && $('#cookies-dialog-personalized')[0].checked;
            const ad = $('#cookies-dialog-ad').length > 0 && $('#cookies-dialog-ad')[0].checked;
            const analytics = $('#cookies-dialog-analytics').length > 0 && $('#cookies-dialog-analytics')[0].checked;
            const provision = $('#cookies-dialog-provision').length > 0 && $('#cookies-dialog-provision')[0].checked;
            const cookieConfig = {
              ad,
              personalized,
              analytics,
              provision
            };
            svs.core.cookie_consent.dataHandler.setConsent(cookieConfig).then(msg => {
              logger.info("Cookie consent info sent to data layer. ".concat(msg));
              const personalizedConsent = new svs.components.analytics.customEvents.PersonalizedConsentChanged(personalized);
              personalizedConsent.track();
              const analyticsConsent = new svs.components.analytics.customEvents.AnalyticsConsentChanged(analytics);
              analyticsConsent.track();
              location.reload(true);
              return true;
            }).catch(err => {
              logger.warn("Unable to send cookie consent info to datalayer. ".concat(err));
            });
            adjustCookiePreferences.close();
          }
        }],
        area: svs.components.dialog.area.POPUP,
        branding: cookieDialogInfoObject.branding,
        allowDimmerClick: false,
        icon: 'gdpr-cookies',
        message,
        title: 'Anpassa',
        type: svs.components.dialog.type.DEFAULT
      });
      svs.components.dialog.api.add(adjustCookiePreferences);
    }
  };
}();
 })(window);